// extracted by mini-css-extract-plugin
export var sub_wrapper = "SubNav-module--sub_wrapper--dbbeb";
export var subnav = "SubNav-module--subnav--660c1";
export var subnav_external = "SubNav-module--subnav_external--5dafe";
export var subnav_icon = "SubNav-module--subnav_icon--84253";
export var subnav_link = "SubNav-module--subnav_link--dfcaa";